import { render } from "./SwiperModal.vue?vue&type=template&id=e9fab0be"
import script from "./SwiperModal.vue?vue&type=script&lang=js"
export * from "./SwiperModal.vue?vue&type=script&lang=js"

import "./SwiperModal.vue?vue&type=style&index=0&id=e9fab0be&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__